import React, { Component } from "react";
import createUndoPlugin from "@draft-js-plugins/undo";
import "@draft-js-plugins/undo/lib/plugin.css";
import "./customToolbarEditor.css";

export const undoPlugin = createUndoPlugin();
const { UndoButton, RedoButton } = undoPlugin;

export default class SimpleUndo extends Component {
  render() {
    return (
      <div className="options">
        <UndoButton />
        <RedoButton />
      </div>
    );
  }
}
